var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_footer"},[_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_c('div',{staticClass:"footer_bot",staticStyle:{"text-decoration":"none"}},[_vm._v("© Copyright  2022-沪ICP备2022030675号-1  陆想汇  -2    All Rights Reserved 上海特陆文化传播有限公司")])])])
}]

export { render, staticRenderFns }